module.exports = __webpack_public_path__ + "img/question_bottom_right.6fc2d33b.svg";